import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";

import Localization from "../../localization";
import Button from "../../components/button";
import IconClose from "../../components/icons/close";
import IconSpinner from "../../components/icons/spinner";
import IconLogo from "../../components/icons/logo";
import Gallery from "../../components/gallery";
import Image from "../../components/image";
import IconEffect1 from "../../components/icons/effect1";
import { fixExternalLinks, getUrl } from "../../utils/helper";
import { loadLesson } from "../../redux/actions/lessons";
import { getArtistDetails } from "../../redux/selectors/artist";
import { getLessonDetails } from "../../redux/selectors/lessons";
import { DateTime } from "luxon";

class LessonDetails extends Component {
    componentDidMount() {
        this.props.loadLesson(this.props.match.params.slug);
    }

    render() {
        const { lesson, locale } = this.props;

        const className =
            "fixed bottom-0 top-0 left-0 flex justify-end right-0 z-20";

        if (!lesson)
            return (
                <div className={className}>
                    <Helmet>
                        <body className="modal-open" />
                    </Helmet>
                    <div className="bg-blue flex flex-col items-center justify-center w-full">
                        <IconSpinner className="animate-spin w-25 xl:w-32 h-25 xl:h-32 text-blue" />
                        <IconLogo
                            className={
                                "w-140 xl:w-208 h-30 xl:h-46 mt-40 text-blue"
                            }
                        />
                    </div>
                </div>
            );

        let lessonDate = DateTime.fromISO(lesson.date);
        let isOver =
            lessonDate.set({ hour: 9, minute: 30 }).diffNow("seconds").seconds <
            0;

        return (
            <div className={className}>
                <Helmet>
                    <body className="modal-open" />
                </Helmet>

                <div className="bg-pink pt-30 xl:pt-40 pb-60 px-16 xl:px-50 overflow-y-auto w-full">
                    <div className="hidden xl:flex justify-end">
                        <Button
                            icon={
                                <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-pink text-blue" />
                            }
                            backgroundColorOver={"bg-blue"}
                            borderColor={"border-blue"}
                            onClick={() => {
                                this.props.history.push(
                                    getUrl("practices/" + lessonDate.toISODate())
                                );
                            }}
                            style={"w-70"}
                        />
                    </div>
                    <div className="flex relative xl:mt-40">
                        <div className="xl:w-4/12" />
                        <div className="xl:w-8/12 mr-60 xl:mr-0">
                            <h1 className="font-bold xl:w-9/12 text-30 xl:text-60 text-blue">
                                {lesson.name}
                            </h1>
                            <div className="xl:hidden absolute right-0 top-0">
                                <Button
                                    icon={
                                        <IconClose className="w-25 h-25 z-10 transition hover-hover:group-hover:text-pink text-blue" />
                                    }
                                    backgroundColorOver={"bg-pink"}
                                    borderColor={"border-pink"}
                                    onClick={() => {
                                        this.props.history.push(
                                            getUrl(
                                                "practices/" +
                                                    lessonDate.toISO()
                                            )
                                        );
                                    }}
                                    style={"w-50"}
                                />
                            </div>
                        </div>
                    </div>
                    {lesson.cover && (
                        <div className="xl:hidden mt-30 w-8/12">
                            <Image
                                alt={lesson.cover.alt || lesson.name}
                                url={lesson.cover.url}
                                aspectRatio="aspect-ratio-3/4"
                            />
                            <p className="text-center mt-10 text-blue">
                                {lesson.caption}
                            </p>
                        </div>
                    )}
                    <div className="flex mt-30 xl:mt-40">
                        <div className="hidden xl:block w-3/12">
                            {lesson.cover && (
                                <Image
                                    alt={lesson.cover.alt || lesson.name}
                                    url={lesson.cover.url}
                                    aspectRatio="aspect-ratio-3/4"
                                />
                            )}
                            <p className="text-center mt-10 text-blue">
                                {lesson.caption}
                            </p>
                        </div>
                        <div className="xl:w-2/12" />
                        <div className="xl:w-7/12">
                            <div className="article-body bio text-17 leading-tight xl:text-23 text-blue xl:w-9/12">
                                <div>
                                    <p className="font-bold">
                                        {lessonDate.toLocaleString(
                                            DateTime.DATE_MED
                                        )}
                                    </p>
                                    <p className="font-bold">{lesson.time}</p>
                                    <p className="font-bold">
                                        {lesson.teacher_name}
                                    </p>
                                </div>
                                {lesson.space_id && !lesson.is_online && (
                                    <p className="font-bold">
                                        {Localization[locale].classes.local +
                                            ": " +
                                            lesson.space.name}
                                    </p>
                                )}
                                {lesson.is_online && (
                                    <p className="font-bold">
                                        {Localization[locale].classes.online}
                                    </p>
                                )}
                                <p className="font-bold">
                                    {Localization[locale].classes.price + ": "}
                                    {lesson.price === 0
                                        ? Localization[locale].classes.free
                                        : lesson.price + " €"}
                                </p>
                            </div>
                            {!isOver && lesson.tickets_url && (
                                <div className="flex mt-30">
                                    <Button
                                        text={
                                            lesson.price > 0
                                                ? Localization[locale].classes
                                                      .buy
                                                : Localization[locale].classes
                                                      .reserve
                                        }
                                        backgroundColorOver={"bg-blue"}
                                        borderColor={"border-blue"}
                                        textStyle={
                                            "font-bold text-20 xl:text-23 z-10 transition hover-hover:group-hover:text-pink text-blue"
                                        }
                                        href={lesson.tickets_url}
                                        style={"w-208"}
                                    />
                                </div>
                            )}
                            <div
                                className="article-body bio text-17 leading-tight xl:text-23 text-blue xl:w-9/12 mt-30"
                                dangerouslySetInnerHTML={{
                                    __html: fixExternalLinks(
                                        lesson.description
                                    ),
                                }}
                            />
                            <div
                                className="article-body bio text-17 leading-tight xl:text-23 text-blue xl:w-9/12 mt-30"
                                dangerouslySetInnerHTML={{
                                    __html: fixExternalLinks(lesson.biography),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => ({
    locale: state.app.locale,
    lesson: getLessonDetails(state, props.match.params.slug),
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            loadLesson,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(LessonDetails);
